/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Creating_Auto_DraftInputs */

const en_case_creating_auto_draft = /** @type {(inputs: Case_Creating_Auto_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing documents…`)
};

const pt_br2_case_creating_auto_draft = /** @type {(inputs: Case_Creating_Auto_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando documentos…`)
};

/**
* | output |
* | --- |
* | "Processing documents…" |
*
* @param {Case_Creating_Auto_DraftInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_creating_auto_draft = /** @type {((inputs?: Case_Creating_Auto_DraftInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Creating_Auto_DraftInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_creating_auto_draft(inputs)
	return pt_br2_case_creating_auto_draft(inputs)
});